module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_4_4.9ca1f33a.jpeg";